import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'jquery';
import 'popper.js';
import 'bootstrap';
import axios from 'axios';
import './sass/app.scss';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueFilterDateParse from '@vuejs-community/vue-filter-date-parse';
import VueFilterDateFormat from '@vuejs-community/vue-filter-date-format';
import vueCountryRegionSelect from "vue-country-region-select";
import ToggleButton from 'vue-js-toggle-button'
import Toasted from 'vue-toasted';
import Vuelidate from 'vuelidate';
import i18n from './i18n';
import { Dataset, DatasetItem, DatasetInfo, DatasetPager, DatasetSearch, DatasetShow } from 'vue-dataset'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import * as VueGoogleMaps from 'vue2-google-maps'

//import 'bootstrap/dist/css/bootstrap.css'
//import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueFilterDateParse);
Vue.use(vueCountryRegionSelect);
Vue.use(ToggleButton);
Vue.use(Vuelidate);
Vue.component('Dataset', Dataset)
Vue.component('DatasetItem', DatasetItem)
Vue.component('DatasetInfo', DatasetInfo)
Vue.component('DatasetPager', DatasetPager)
Vue.component('DatasetSearch', DatasetSearch)
Vue.component('DatasetShow', DatasetShow)
Vue.component('VueSlider', VueSlider)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAkB_1uO5LO0O01DcOfMqK8txarQdjx968',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
})

Vue.use(Toasted, {
    position: "top-right",
    theme: "bubble",
    duration: 4000
});

Vue.use(VueFilterDateFormat, {
    dayOfWeekNames: [
        'Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves',
        'Viernes', 'Sábado'
    ],
    dayOfWeekNamesShort: [
        'Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'
    ],
    monthNames: [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ],
    monthNamesShort: [
        'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
        'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
    ],
    // Timezone offset, in minutes (0 - UTC, 180 - Russia, undefined - current)
    timezone: 0
});

Vue.component('dynamicform-file-upload', require('./components/DynamicForms/FileUpload').default);
Vue.component('dynamicform-input-text', require('./components/DynamicForms/InputText').default);
Vue.component('dynamicform-textarea', require('./components/DynamicForms/Textarea').default);
Vue.component('dynamicform-select', require('./components/DynamicForms/Select').default);
Vue.filter('toCurrency', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    let formatter = new Intl.NumberFormat("es-ES", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });
    return formatter.format(value);
})

var vueObject = new Vue({
    router,
    store,
    BootstrapVue,
    IconsPlugin,
    VueFilterDateParse,
    VueFilterDateFormat,
    i18n,
    render: h => h(App)
}).$mount('#cocinas_bloque');

if (vueObject.$store.getters['authentication/isAuthenticated']) {
    axios.defaults.headers.common.Authorization = 'Bearer ' + vueObject.$store.getters['authentication/accessToken'];
}



// WEBPACK FOOTER //
// ./src/main.js